export default __webpack_public_path__ + "img/8af2626da84e143e0c3178ad8fd758c9.png";